// Single type scale for the whole app: seven sizes (11 · 12 · 13 · 14 · 16 ·
// 24 · 32/48). Every `fontSize` in an `sx` prop comes from here, and the
// theme maps every Typography variant onto the same steps — ad-hoc rem
// literals (0.62, 0.72, 0.78…) are what made the UI read as uneven. 11px is
// for chart ticks and labels only; 12px is the floor for any other text.

/** Font sizes, rem (base 16px). */
export const FS = {
  /** 11px — chart ticks and in-chart labels only. */
  caption: '0.6875rem',
  /** 12px — captions, table meta, uppercase labels, chips. */
  xs: '0.75rem',
  /** 13px — dense table cells, secondary body. */
  sm: '0.8125rem',
  /** 14px — body, section titles inside cards. */
  md: '0.875rem',
  /** 16px — card / section headings. */
  lg: '1rem',
  /** 24px — KPI figures. */
  xl: '1.5rem',
  /** 32px — page titles. */
  display: '2rem',
  /** 48px — the one hero figure. */
  hero: '3rem',
} as const;

/** Figures: Aeonik with tabular numerals (set app-wide in the theme) keeps
 * columns aligned without the typewriter look of Aeonik Mono at display
 * sizes. Flip back to FONT_MONO here to restore mono figures everywhere. */
export const FONT_NUM = '"Aeonik", sans-serif';
/** Code, IDs, formulas. */
export const FONT_MONO = '"Aeonik Mono", monospace';

/** Two weights only: regular text and emphasis. No 600/700. */
export const FW = {
  regular: 400,
  medium: 500,
} as const;

/** Tracking for uppercase labels (eyebrows, column headers). */
export const LABEL_TRACKING = '0.06em';

